import { useQuery } from "@tanstack/react-query";
import adminApiClient from "../../../api/admin";

interface UseClockQueryOptions {
  enabled?: boolean;
}

const useClockQuery = (
  clockId: string | undefined,
  options?: UseClockQueryOptions,
) => {
  return useQuery({
    queryKey: ["clock", clockId],
    queryFn: () => adminApiClient.getClock(clockId!),
    enabled: !!clockId && (options?.enabled ?? true),
  });
};

export default useClockQuery;
